import { useNavigate } from "react-router-dom"

import Style from "./style"
import useSaveToken from "../Home/model/useSaveToken"
import AdBanner from "./ui/AdBanner"
import youtube from "./asset/youtube.svg"
import media from "./asset/media.svg"
import detail from "./asset/detail.svg"
import exam from "./asset/exam.svg"

import FooterPage from "widget/FooterPage"

import useGetNoticeList from "entity/column/useGetNoticeList"
import useGetYoutubeList from "entity/column/useGetYoutubeList"
import useGetMediaList from "entity/column/useGetMediaList"

import timestampCalculator from "shared/lib/timestampCalculator"

const Home = () => {
    const navigate = useNavigate()

    const [noticeList] = useGetNoticeList()
    const [youtubeList] = useGetYoutubeList()
    const [mediaList] = useGetMediaList()

    useSaveToken()

    return (
        <FooterPage>

            <AdBanner />

            <Style.Content>

                <Style.NoticeDiv>
                    <h2>공지사항</h2>
                    <Style.NoticeList>
                        {noticeList?.data?.notice_list?.map(elem =>
                            <Style.NoticeElem onClick={() => navigate(`/notice/${elem?.idx}/detail`)}>
                                <h2>{elem?.title}</h2>
                                <p>{timestampCalculator(elem?.created_at, "date")}</p>
                            </Style.NoticeElem>
                        )}
                        {noticeList?.data?.notice_list?.length < 1 && <Style.Option>아직 공지사항이 작성되지 않았습니다.</Style.Option>}
                    </Style.NoticeList>
                </Style.NoticeDiv>

                <Style.ArticleDiv>
                    <Style.ArticleTitleDiv>
                        <div>
                            <img src={youtube} />
                            <h2>유튜브</h2>
                        </div>
                        <button onClick={() => navigate(`/youtube`)}>
                            <img src={detail} />
                        </button>
                    </Style.ArticleTitleDiv>
                    <Style.YoutubeList>
                        {youtubeList?.data?.youtube_list?.map(elem =>
                            <Style.YoutubeElement onClick={() => window.location.href = elem?.url}>
                                <img src={elem?.img} />
                                <h2>{elem?.title}</h2>
                                <p>{timestampCalculator(elem?.created_at, "date")}</p>
                            </Style.YoutubeElement>
                        )}
                        {youtubeList?.data?.youtube_list?.length < 1 && <Style.Option>아직 유튜브 영상이 작성되지 않았습니다.</Style.Option>}
                    </Style.YoutubeList>
                </Style.ArticleDiv>

                <Style.ArticleDiv>
                    <Style.ArticleTitleDiv>
                        <div>
                            <img src={media} />
                            <h2>미디어</h2>
                        </div>
                        <button onClick={() => navigate(`/media`)}>
                            <img src={detail} />
                        </button>
                    </Style.ArticleTitleDiv>
                    <Style.MediaList>
                        {mediaList?.data?.media_list?.map(elem =>
                            <Style.MediaElement onClick={() => window.location.href = elem.url}>
                                <div>
                                    <h2>{elem.title}</h2>
                                    <p>{timestampCalculator(elem.created_at, "date")}</p>
                                </div>
                                <img src={elem.img} />
                                {mediaList?.data?.media_list?.length < 1 && <Style.Option>아직 미디어가 작성되지 않았습니다.</Style.Option>}
                            </Style.MediaElement>
                        )}
                    </Style.MediaList>
                </Style.ArticleDiv>

                <Style.ArticleTitleDiv $borderless>
                    <div>
                        <img src={exam} />
                        <h2>트라이아웃 필기 시험 응시하기</h2>
                    </div>
                    <button onClick={() => navigate(`/tryout`)}>
                        <img src={detail} />
                    </button>
                </Style.ArticleTitleDiv>

            </Style.Content>

        </FooterPage>

    )
}

export default Home